import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import HeroSlider from '../components/HeroSlider';
import { fetchSuppliersPublic } from '../lib/suppliers';
import { fetchReferencesPublic } from '../lib/references';
import { fetchCategories } from '../lib/categories';
import { fetchServicesPublic } from '../lib/services';
import { fetchProjectsByCategory } from '../lib/projects';
import { fetchEventsPublic } from '../lib/events';
import { fetchTeamPublic } from '../lib/team';
import { getFileUrl, pb } from '../lib/pb';


export default function Home() {
  const [suppliers, setSuppliers] = useState([]);
  const [references, setReferences] = useState([]);
  const [services, setServices] = useState([]);
  const [projects, setProjects] = useState([]);
  const [featuredProjects, setFeaturedProjects] = useState([]);
  const [events, setEvents] = useState([]);
  const [team, setTeam] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [catalogueCategories, setCatalogueCategories] = useState([]);
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);
  const [serviceIndex, setServiceIndex] = useState(0);
  const [serviceColumns, setServiceColumns] = useState(1);
  const [warrantyOpen, setWarrantyOpen] = useState(false);

  const googleReviews = [
    {
      name: 'Yannick Gout',
      meta: '3 avis · 8 photos',
      time: 'il y a 11 mois',
      text: "Un partenariat à la hauteur des exigences de notre Entreprise ORONA Sud-Ouest. Du personnel hautement qualifié et consciencieux. Merci à eux !",
    },
    {
      name: 'Martine Dugoujon',
      meta: '2 avis · Nouveau',
      time: 'il y a une semaine',
      text: "Réparation de notre portail électrique après plusieurs moi de panne, équipe très efficace, sympathique et réactive. Merci",
    },
    {
      name: 'Patricia FOULQUIER BOURREC',
      meta: 'Local Guide · 20 avis',
      time: 'il y a 6 mois',
      text: "Service impeccable, très professionnel et avec le sourire en plus, explication et mise en service parfaite pour notre porte de garage électrique. Je recommande les yeux fermés",
    },
    {
      name: 'HOPS Ma31',
      meta: '3 avis',
      time: 'il y a un an',
      text: "Excellente prestation de la partie d'AEF32 pour la pose de notre rideau motorisé. Une équipe professionnelle, efficace et à l'écoute. Je recommande leurs services pour tous vos projets de portails, rideaux et motorisation.",
    },
    {
      name: 'Nelly Casasola',
      meta: '2 avis',
      time: 'il y a 9 mois',
      text: "Installation motorisation sur portail et porte du garage. Très satisfaits des installations qui plus est sur la porte du garage qui a nécessité une adaptation. Recommandons pour le sérieux, l'efficacité et l'amabilité.",
    },
    {
      name: 'tetaud franck',
      meta: '4 avis',
      time: 'il y a 11 mois',
      text: "AEF32 est un partenaire efficace, sérieux et professionnel. Le travail est toujours soigné ! Je le recommande sans hésiter.",
    },
  ];


  useEffect(() => {
    let cancelled = false;
    async function load() {
      setLoading(true);
      setError('');
      try {
        const [s, r, sv, pj, ev, tm, fp] = await Promise.all([
          fetchSuppliersPublic(),
          fetchReferencesPublic(),
          fetchServicesPublic(),
          fetchProjectsByCategory(null),
          fetchEventsPublic(),
          fetchTeamPublic(),
          (async () => {
            try {
              const res = await pb.collection('projects').getList(1, 6, {
                filter: 'published=true && featured=true',
                sort: 'order,-date,title',
              });
              return res.items || [];
            } catch { return []; }
          })(),
        ]);
        if (!cancelled) {
          setSuppliers(s);
          setReferences(r);
          setServices(sv || []);
          setProjects(pj || []);
          setFeaturedProjects(fp || []);
          setEvents(ev || []);
          setTeam(tm || []);
        }
      } catch (e) {
        if (!cancelled) {
          setError(e.message || 'Erreur lors du chargement des partenaires');
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }
    load();
    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    if (!services.length) return;
    setServiceIndex(0);
    const id = setInterval(() => {
      setServiceIndex(prev => (prev + serviceColumns) % services.length);
    }, 6000);
    return () => clearInterval(id);
  }, [services.length, serviceColumns]);

  useEffect(() => {
    function handleResize() {
      const w = window.innerWidth;
      setIsMobile(w <= 700);
      if (w <= 700) {
        setServiceColumns(1);
      } else if (w <= 1024) {
        setServiceColumns(2);
      } else {
        setServiceColumns(3);
      }
    }
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    let cancelled = false;
    async function loadCats() {
      try {
        const cats = await fetchCategories('catalogue');
        if (!cancelled) {
          setCatalogueCategories(cats.filter(c => !c.parent));
        }
      } catch {
        // silencieux sur la home
      }
    }
    loadCats();
    return () => { cancelled = true; };
  }, []);


  return (
    <>
      <HeroSlider />
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: 16 }}>
        <div style={{ textAlign: 'center', maxWidth: 700 }}>
          <h1 style={{ marginBottom: 8, fontSize: 24 }}>Votre expert en portails et automatismes</h1>
          <p style={{ fontSize: 16 }}>En Occitanie, pour des solutions fiables, sur mesure, et adaptées à tous vos projets.</p>
        </div>
      </div>

      {catalogueCategories.length > 0 && (
        <section className="home-catalogue-signature animated-up">
          <div className="container-about-premium">
            <header className="section-header-signature">
              <div className="tag-line-premium">COLLECTIONS AEF32</div>
              <h2>Nos Produits Excellence</h2>
              <p className="section-intro-text">Découvrez nos gammes par catégorie, puis explorez le détail dans le catalogue.</p>
              <div className="accent-bar-horiz centered-bar"></div>
            </header>

            <div className="gammes-grid-home">
              {catalogueCategories.map(cat => (
                <button
                  key={cat.id}
                  type="button"
                  className="gamme-card-royale shadow-signature"
                  onClick={() => navigate(`/catalogue/${encodeURIComponent(cat.slug || '')}`)}
                >
                  <div className="gamme-visual">
                    {cat.image ? (
                      <img
                        src={getFileUrl(cat, cat.image)}
                        alt={cat.name}
                        loading="lazy"
                      />
                    ) : (
                      <div className="placeholder-gamme">📂</div>
                    )}
                    <div className="gamme-overlay-glass">
                      <span>Explorer</span>
                    </div>
                  </div>
                  <div className="gamme-footer">
                    <span className="gamme-name">{cat.name}</span>
                    <div className="arrow-gamme">→</div>
                  </div>
                </button>
              ))}
            </div>
          </div>

          <style>{`
            .home-catalogue-signature { padding: 80px 0; background: #fff; }
            .container-about-premium { max-width: 1200px; margin: 0 auto; padding: 0 20px; }
            
            .section-header-signature { text-align: center; margin-bottom: 50px; }
            .section-header-signature h2 { font-size: clamp(28px, 4vw, 38px); font-weight: 900; margin: 10px 0 15px 0; letter-spacing: -1.5px; }
            .section-intro-text { font-size: 18px; color: #64748b; max-width: 700px; margin: 0 auto; }
            .centered-bar { margin: 25px auto 0 auto; }

            .tag-line-premium { 
               font-size: 12px; font-weight: 900; color: #22c55e; letter-spacing: 4px; 
               text-transform: uppercase; margin-bottom: 15px; opacity: 0.9;
               display: block;
            }
            .accent-bar-horiz { width: 60px; height: 3px; background: #22c55e; border-radius: 99px; }

            .gammes-grid-home { 
               display: grid; 
               grid-template-columns: repeat(4, 1fr); 
               gap: 25px; 
               margin-top: 40px;
            }

            .gamme-card-royale { 
               background: #fff; border-radius: 28px; border: 1px solid #f1f5f9;
               padding: 12px; cursor: pointer; transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
               display: flex; flex-direction: column; text-align: left; width: 100%;
            }
            .gamme-card-royale:hover { transform: translateY(-10px); border-color: #22c55e; }
            
            .gamme-visual { height: 200px; border-radius: 20px; overflow: hidden; position: relative; background: #f8fafc; }
            .gamme-visual img { width: 100%; height: 100%; object-fit: cover; transition: transform 0.8s ease; }
            .gamme-card-royale:hover .gamme-visual img { transform: scale(1.15); }
            
            .gamme-overlay-glass { 
               position: absolute; inset: 0; background: rgba(15,23,42,0.2); 
               backdrop-filter: blur(4px); display: flex; align-items: center; justify-content: center;
               opacity: 0; transition: all 0.4s;
            }
            .gamme-overlay-glass span { 
               background: #fff; color: #0f172a; padding: 10px 22px; border-radius: 99px; 
               font-size: 13px; font-weight: 800; transform: translateY(10px); transition: all 0.4s;
            }
            .gamme-card-royale:hover .gamme-overlay-glass { opacity: 1; }
            .gamme-card-royale:hover .gamme-overlay-glass span { transform: translateY(0); }

            .gamme-footer { padding: 18px 8px 8px 8px; display: flex; justify-content: space-between; align-items: center; }
            .gamme-name { font-size: 16px; font-weight: 900; color: #0f172a; transition: color 0.3s; }
            .gamme-card-royale:hover .gamme-name { color: #22c55e; }
            .arrow-gamme { color: #22c55e; opacity: 0; transform: translateX(-10px); transition: all 0.3s; font-size: 18px; font-weight: 900; }
            .gamme-card-royale:hover .arrow-gamme { opacity: 1; transform: translateX(0); }

            @media (max-width: 1024px) {
               .gammes-grid-home { grid-template-columns: repeat(3, 1fr); }
            }
            @media (max-width: 768px) {
               .gammes-grid-home { grid-template-columns: repeat(2, 1fr); gap: 15px; }
               .gamme-visual { height: 150px; }
               .home-catalogue-signature { padding: 50px 0; }
            }
          `}</style>
        </section>
      )}

      {!!suppliers.length && !error && (
        <section className="home-suppliers-signature animated-up" style={{ animationDelay: '0.2s' }}>
          <div className="container-about-premium">
            <header className="section-header-signature">
              <div className="tag-line-premium">PARTENAIRES DE CONFIANCE</div>
              <h2>Nos Fournisseurs Élite</h2>
              <p className="section-intro-text">Des fabricants sélectionnés pour la qualité et la fiabilité de leurs produits.</p>
              <div className="accent-bar-horiz centered-bar"></div>
            </header>

            <div className="suppliers-cloud-signature">
              {suppliers.map(s => {
                const logo = s.logo ? (
                  <img
                    src={getFileUrl(s, s.logo)}
                    alt={s.name}
                    className="supplier-logo-img"
                  />
                ) : (
                  <span className="supplier-name-text">{s.name}</span>
                );

                return s.website ? (
                  <a
                    key={s.id}
                    href={s.website}
                    target="_blank"
                    rel="noreferrer"
                    className="supplier-pill-link shadow-signature"
                  >
                    {logo}
                  </a>
                ) : (
                  <div key={s.id} className="supplier-pill-link shadow-signature">
                    {logo}
                  </div>
                );
              })}
            </div>
          </div>

          <style>{`
            .home-suppliers-signature { padding: 80px 0; background: #fff; }
            .suppliers-cloud-signature { 
               display: flex; flex-wrap: wrap; justify-content: center; 
               align-items: center; gap: 30px; margin-top: 50px; 
               max-width: 1100px; margin-left: auto; margin-right: auto;
            }

            .supplier-pill-link { 
               background: #fff; border: 1px solid #f1f5f9; 
               border-radius: 50%; display: flex; align-items: center; justify-content: center;
               transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1); 
               width: 150px; height: 150px; aspect-ratio: 1/1;
               text-decoration: none; padding: 30px;
               box-shadow: 0 10px 30px rgba(15,23,42,0.03);
               flex-shrink: 0; overflow: hidden; position: relative;
            }
            .supplier-pill-link:hover { 
               transform: translateY(-10px); border-color: #22c55e; 
               box-shadow: 0 20px 50px rgba(34, 197, 94, 0.12); 
            }

            .supplier-logo-img { 
               max-width: 100%; max-height: 100%; 
               width: auto; height: auto; 
               object-fit: contain; 
               display: block;
               transition: transform 0.4s;
            }
            .supplier-pill-link:hover .supplier-logo-img { transform: scale(1.1); }

            .supplier-name-text { 
               font-size: 13px; font-weight: 800; color: #1e293b; 
               text-transform: uppercase; letter-spacing: 1px; text-align: center; 
               line-height: 1.2;
            }

            @media (max-width: 768px) {
               .supplier-pill-link { width: 110px; height: 110px; padding: 20px; }
               .suppliers-cloud-signature { gap: 20px; padding: 0 15px; }
            }
          `}</style>
        </section>
      )}

      {events.length > 0 && (
        <section style={{ marginTop: 40, background: '#fff' }}>
          <div style={{ maxWidth: 960, margin: '0 auto', padding: '24px 20px 32px 20px' }}>
            <h2 style={{ fontSize: 24, marginBottom: 6, textAlign: 'center' }}>Agenda</h2>
            <p style={{ textAlign: 'center', margin: 0, color: '#6b7280', fontSize: 16 }}>Retrouvez nos prochains événements, démonstrations et portes ouvertes.</p>
            <div style={{ marginTop: 20, display: 'grid', gap: 12 }}>
              {events.slice(0, 3).map(event => {
                const date = event.start_at ? new Date(event.start_at) : null;
                const formatted = date ? date.toLocaleDateString('fr-FR', { day: '2-digit', month: 'short', year: 'numeric' }) : '';
                return (
                  <div
                    key={event.id}
                    style={{
                      borderRadius: 12,
                      background: '#fff',
                      border: '1px solid #e5e7eb',
                      padding: 12,
                      display: 'grid',
                      gridTemplateColumns: isMobile ? '1fr' : '120px 1fr',
                      gap: 12,
                      alignItems: 'center',
                    }}
                  >
                    <div style={{ textAlign: 'center' }}>
                      {formatted && (
                        <div style={{ fontWeight: 600, fontSize: 16 }}>{formatted}</div>
                      )}
                      {event.location && (
                        <div style={{ fontSize: 13, color: '#6b7280' }}>{event.location}</div>
                      )}
                    </div>
                    <div>
                      <div style={{ fontWeight: 600, fontSize: 16 }}>{event.title}</div>
                      {event.excerpt && (
                        <p style={{ margin: '4px 0 0 0', fontSize: 14, color: '#6b7280' }}>{event.excerpt}</p>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
            <div style={{ marginTop: 20, textAlign: 'center' }}>
              <button
                type="button"
                onClick={() => navigate('/agenda')}
                className="btn outline"
              >
                Voir tout l&apos;agenda
              </button>
            </div>
          </div>
        </section>
      )}



      {(featuredProjects.length > 0 ? featuredProjects : projects).length > 0 && (
        <section className="home-projects-signature animated-up">
          <div className="container-about-premium">
            <header className="section-header-signature">
              <div className="tag-line-premium">DÉMONSTRATION DE TALENT</div>
              <h2>Nos Réalisations Signature</h2>
              <p className="section-intro-text">
                {featuredProjects.length > 0 ? 'Sélection de projets d&apos;exception mise en avant par notre équipe.' : 'Quelques projets récents réalisés pour nos clients en Occitanie.'}
              </p>
              <div className="accent-bar-horiz centered-bar"></div>
            </header>

            <div className="projects-grid-home">
              {(featuredProjects.length > 0 ? featuredProjects.slice(0, 3) : projects.slice(0, 3)).map((project, idx) => (
                <div
                  key={project.id}
                  className="project-card-royale shadow-signature"
                  onClick={() => { if (project.slug) navigate(`/realisations/${encodeURIComponent(project.slug)}`); }}
                  style={{ animationDelay: `${idx * 0.15}s` }}
                >
                  <div className="project-visual-wrap">
                    {project.gallery && project.gallery.length > 0 ? (
                      <img
                        src={getFileUrl(project, project.gallery[0])}
                        alt={project.title}
                        className="project-main-img"
                      />
                    ) : (
                      <div className="project-placeholder">🏗️</div>
                    )}
                    <div className="project-badge-loc">📍 {project.location || 'Occitanie'}</div>
                  </div>
                  <div className="project-footer-royale">
                    <h3 className="project-title-link">{project.title}</h3>
                    <div className="project-arrow-gold">Découvrir →</div>
                  </div>
                </div>
              ))}
            </div>

            <div className="projects-cta-wrap">
              <button
                type="button"
                onClick={() => navigate('/realisations')}
                className="btn-premium-emerald"
              >
                Explorer tout le portfolio
              </button>
            </div>
          </div>

          <style>{`
            .home-projects-signature { padding: 90px 0; background: #fff; }
            .projects-grid-home { 
               display: grid; 
               grid-template-columns: repeat(3, 1fr); 
               gap: 35px; 
               margin-top: 50px;
            }

            .project-card-royale { 
               background: #fff; border-radius: 32px; overflow: hidden; 
               border: 1px solid #f1f5f9; cursor: pointer; transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
               display: flex; flex-direction: column;
            }
            .project-card-royale:hover { transform: translateY(-12px); border-color: #22c55e; }

            .project-visual-wrap { height: 260px; position: relative; overflow: hidden; background: #f1f5f9; }
            .project-main-img { width: 100%; height: 100%; object-fit: cover; transition: transform 0.8s ease; }
            .project-card-royale:hover .project-main-img { transform: scale(1.12); }
            
            .project-badge-loc { 
               position: absolute; top: 20px; right: 20px; background: rgba(15,23,42,0.8);
               backdrop-filter: blur(8px); color: #fff; padding: 6px 14px; border-radius: 99px;
               font-size: 11px; font-weight: 800; letter-spacing: 0.5px;
            }

            .project-footer-royale { padding: 25px; border-top: 1px solid #f1f5f9; flex-grow: 1; display: flex; flex-direction: column; }
            .project-title-link { font-size: 18px; font-weight: 900; color: #0f172a; margin: 0 0 15px 0; line-height: 1.4; transition: color 0.3s; }
            .project-card-royale:hover .project-title-link { color: #22c55e; }
            
            .project-arrow-gold { 
               font-size: 13px; font-weight: 800; color: #22c55e; margin-top: auto; 
               text-transform: uppercase; letter-spacing: 1px; transition: transform 0.3s;
            }
            .project-card-royale:hover .project-arrow-gold { transform: translateX(5px); }

            .btn-premium-emerald { 
               background: var(--accent); color: #fff; padding: 14px 34px; border-radius: 99px; 
               font-size: 14px; font-weight: 900; border: none; cursor: pointer; transition: all 0.3s ease;
               box-shadow: 0 10px 20px rgba(34, 197, 94, 0.2); text-transform: uppercase; letter-spacing: 1px;
            }
            .btn-premium-emerald:hover { background: var(--accent-600); transform: translateY(-3px); box-shadow: 0 15px 30px rgba(34, 197, 94, 0.3); }

             .projects-cta-wrap { display: flex; justify-content: center; margin-top: 50px; }

             @media (max-width: 1024px) {
                .projects-grid-home { grid-template-columns: repeat(2, 1fr); gap: 20px; }
                .project-visual-wrap { height: 200px; }
             }
             @media (max-width: 768px) {
                .projects-grid-home { grid-template-columns: 1fr; }
                .home-projects-signature { padding: 60px 0; }
             }
           `}</style>
        </section>
      )}

      {/* Garantie de fabrication */}
      <section className="home-warranty-signature animated-up">
        <div className="container-about-premium">
          <header className="section-header-signature">
            <div className="tag-line-premium">DURABILITÉ & CONFIANCE</div>
            <h2>Garanties Excellence</h2>
            <p className="section-intro-text">Des engagements clairs et durables pour la pérennité de vos installations.</p>
            <div className="accent-bar-horiz centered-bar"></div>
          </header>

          <div className="warranty-grid-signature">
            <article className="warranty-card-elite shadow-signature">
              <div className="warranty-icon-orb">
                <span className="warranty-symbol-gold">∞</span>
              </div>
              <h3 className="warranty-duration">Garantie à Vie</h3>
              <p className="warranty-scope">Portails haute performance (hors accessoires et motorisation).</p>
            </article>

            <article className="warranty-card-elite shadow-signature" style={{ animationDelay: '0.1s' }}>
              <div className="warranty-icon-orb">
                <span className="warranty-symbol-emoji">🛡️</span>
              </div>
              <h3 className="warranty-duration">25 Ans de Sérénité</h3>
              <p className="warranty-scope">Clôtures, garde-corps (hors verre) et brise-vues techniques.</p>
            </article>

            <article className="warranty-card-elite shadow-signature" style={{ animationDelay: '0.2s' }}>
              <div className="warranty-icon-orb">
                <span className="warranty-symbol-emoji">⚙️</span>
              </div>
              <h3 className="warranty-duration">5 Ans Motorisation</h3>
              <p className="warranty-scope">Tous les systèmes motorisés Pro DEA Partenaire certifiés.</p>
            </article>
          </div>

          <footer className="warranty-legal-footer">
            <p className="warranty-disclaimer">
              Sous réserve du respect des conditions d’utilisation et d’entretien.
              Déclaration obligatoire sous 15 jours à compter de la livraison de votre équipement.
            </p>
            <div className="warranty-action-wrap">
              <button
                type="button"
                className="btn-signature-ghost"
                onClick={() => setWarrantyOpen(true)}
              >
                Consulter les conditions détaillées
              </button>
            </div>
          </footer>
        </div>

        <style>{`
          .home-warranty-signature { padding: 90px 0; background: #fff; }
          .warranty-grid-signature { 
             display: grid; 
             grid-template-columns: repeat(3, 1fr); 
             gap: 30px; 
             margin-top: 50px;
          }

          .warranty-card-elite { 
             background: #fff; border-radius: 32px; border: 1px solid #f1f5f9; padding: 45px 30px;
             text-align: center; display: flex; flex-direction: column; align-items: center;
             transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
          }
          .warranty-card-elite:hover { transform: scale(1.03); border-color: #22c55e; }
          
          .warranty-icon-orb { 
             width: 80px; height: 80px; border-radius: 50%; background: #f0fdf4; 
             border: 1px solid rgba(34, 197, 94, 0.1); display: flex; align-items: center;
             justify-content: center; margin-bottom: 25px; transition: all 0.3s;
          }
          .warranty-card-elite:hover .warranty-icon-orb { background: #22c55e; transform: rotate(10deg); color: #fff; }

          .warranty-symbol-gold { font-size: 32px; font-weight: 200; color: #22c55e; transition: color 0.3s; }
          .warranty-symbol-emoji { font-size: 32px; }
          .warranty-card-elite:hover .warranty-symbol-gold { color: #fff; }

          .warranty-duration { font-size: 20px; font-weight: 900; color: #0f172a; margin: 0 0 12px 0; }
          .warranty-scope { font-size: 15px; color: #64748b; line-height: 1.6; margin: 0; }

          .warranty-legal-footer { margin-top: 50px; text-align: center; }
          .warranty-disclaimer { font-size: 13px; color: #94a3b8; max-width: 600px; margin: 0 auto 25px auto; line-height: 1.5; }
          
          .btn-signature-ghost { 
             background: transparent; color: #22c55e; border: 2px solid #22c55e; 
             padding: 12px 30px; border-radius: 99px; font-size: 13px; font-weight: 800;
             cursor: pointer; transition: all 0.3s; text-transform: uppercase; letter-spacing: 1px;
          }
          .btn-signature-ghost:hover { background: #22c55e; color: #fff; box-shadow: 0 10px 20px rgba(34, 197, 94, 0.1); }

          @media (max-width: 1024px) {
             .warranty-grid-signature { grid-template-columns: repeat(2, 1fr); gap: 20px; }
          }
          @media (max-width: 768px) {
             .warranty-grid-signature { grid-template-columns: 1fr; }
             .home-warranty-signature { padding: 60px 0; }
          }
        `}</style>
      </section>

      {/* Fabriqué en France */}
      <section style={{ marginTop: 40, padding: isMobile ? '0 12px' : 0 }}>
        <div style={{ maxWidth: 960, margin: '0 auto', padding: '24px 20px', border: '1px solid #e5e7eb', borderRadius: 16, background: '#ffffff', boxShadow: '0 8px 22px rgba(15,23,42,0.06)' }}>
          <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 220px', gap: 20, alignItems: 'center' }}>
            <div>
              <h2 style={{ fontSize: 24, marginBottom: 6 }}>Fabriqué en France</h2>
              <p style={{ margin: 0, color: '#6b7280', fontSize: 16 }}>
                Nous privilégions des produits conçus et fabriqués en France, gage de qualité,
                de durabilité et de proximité. Un choix qui soutient le savoir‑faire local et
                réduit l'empreinte logistique.
              </p>
            </div>
            <div style={{ textAlign: 'center' }}>
              <img
                src="/images/fabrique-en-france.png"
                alt="Fabriqué en France"
                style={{ maxWidth: 200, width: '100%', height: 'auto', objectFit: 'contain' }}
              />
            </div>
          </div>
        </div>
      </section>

      {services.length > 0 && (
        <section style={{ marginTop: 40, background: '#fff' }}>
          <div style={{ maxWidth: 1200, margin: '0 auto', padding: '24px 20px 32px 20px' }}>
            <h2 style={{ fontSize: 24, marginBottom: 6, textAlign: 'center' }}>Nos services</h2>
            <p style={{ textAlign: 'center', margin: 0, color: '#6b7280', fontSize: 16 }}>De l&apos;étude de votre projet à la maintenance, AEF32 vous accompagne à chaque étape.</p>
            <div style={{ marginTop: 20, position: 'relative' }}>
              <button
                type="button"
                aria-label="Services précédents"
                onClick={() => {
                  if (!services.length) return;
                  setServiceIndex(prev => {
                    const step = serviceColumns || 1;
                    const len = services.length;
                    return (prev - step + len * 10) % len;
                  });
                }}
                style={{
                  position: 'absolute',
                  left: 0,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  borderRadius: 999,
                  border: '1px solid #e5e7eb',
                  background: '#fff',
                  width: 30,
                  height: 30,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  boxShadow: '0 4px 10px rgba(15,23,42,0.15)',
                  fontSize: 16,
                  color: '#4b5563',
                }}
              >
                ‹
              </button>
              <button
                type="button"
                aria-label="Services suivants"
                onClick={() => {
                  if (!services.length) return;
                  setServiceIndex(prev => {
                    const step = serviceColumns || 1;
                    const len = services.length;
                    return (prev + step) % len;
                  });
                }}
                style={{
                  position: 'absolute',
                  right: 0,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  borderRadius: 999,
                  border: '1px solid #e5e7eb',
                  background: '#fff',
                  width: 30,
                  height: 30,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  boxShadow: '0 4px 10px rgba(15,23,42,0.15)',
                  fontSize: 16,
                  color: '#4b5563',
                }}
              >
                ›
              </button>
              <div
                style={{
                  display: 'grid',
                  gap: 16,
                  gridTemplateColumns: `repeat(${Math.min(serviceColumns, services.length || 1)}, minmax(0, 1fr))`,
                  padding: '0 44px',
                }}
              >
                {services.length > 0 &&
                  Array.from({ length: Math.min(serviceColumns, services.length) }, (_, i) => {
                    const idx = (serviceIndex + i) % services.length;
                    const service = services[idx];
                    return (
                      <div
                        key={service.id}
                        style={{
                          borderRadius: 14,
                          background: '#fff',
                          padding: 20,
                          boxShadow: '0 10px 30px rgba(15,23,42,0.08)',
                          border: '1px solid #e5e7eb',
                          display: 'flex',
                          flexDirection: 'column',
                          gap: 8,
                          alignItems: 'center',
                          textAlign: 'center',
                        }}
                      >
                        {service.icon && (
                          <div style={{ width: 72, height: 72, borderRadius: 999, background: '#f1f5f9', border: '1px solid #e2e8f0', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 8, overflow: 'hidden' }}>
                            <img
                              src={getFileUrl(service, service.icon)}
                              alt={service.title}
                              style={{ width: '70%', height: '70%', objectFit: 'contain' }}
                            />
                          </div>
                        )}
                        <h3 style={{ margin: 0, fontSize: 18 }}>{service.title}</h3>
                        {service.excerpt && (
                          <p style={{ margin: 0, fontSize: 14, color: '#6b7280' }}>{service.excerpt}</p>
                        )}
                      </div>
                    );
                  })}
              </div>
            </div>
            <div style={{ marginTop: 16, display: 'flex', justifyContent: 'center', gap: 8 }}>
              {services.map((service, idx) => (
                <button
                  key={service.id}
                  type="button"
                  onClick={() => setServiceIndex(idx)}
                  aria-label={`Afficher le service ${service.title}`}
                  style={{
                    width: 9,
                    height: 9,
                    borderRadius: 999,
                    border: '1px solid rgba(148,163,184,0.9)',
                    padding: 0,
                    cursor: 'pointer',
                    background: idx === serviceIndex ? 'rgba(148,163,184,0.95)' : 'rgba(226,232,240,0.8)',
                  }}
                />
              ))}
            </div>
            <div style={{ marginTop: 20, textAlign: 'center' }}>
              <button
                type="button"
                onClick={() => navigate('/services')}
                className="btn outline"
              >
                Découvrir tous nos services
              </button>
            </div>
          </div>
        </section>
      )}

      {error && <p style={{ color: 'crimson', marginTop: 16 }}>{error}</p>}

      {team.length > 0 && (
        <section style={{ marginTop: 40 }}>
          <div style={{ maxWidth: 1200, margin: '0 auto', padding: '0 20px' }}>
            <h2 style={{ fontSize: 24, marginBottom: 6, textAlign: 'center' }}>Une équipe à votre écoute</h2>
            <p style={{ textAlign: 'center', margin: 0, color: '#6b7280', fontSize: 16 }}>Des professionnels spécialisés dans les portails et automatismes, proches de vos besoins.</p>
            <div
              style={{
                marginTop: 20,
                display: 'grid',
                gridTemplateColumns: isMobile
                  ? 'repeat(2, minmax(0, 1fr))'
                  : 'repeat(4, minmax(0, 1fr))',
                gap: 20,
              }}
            >
              {team.slice(0, 4).map(member => (
                <div
                  key={member.id}
                  style={{
                    textAlign: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 8,
                  }}
                >
                  <div style={{ width: 96, height: 96, borderRadius: 999, overflow: 'hidden', background: '#e5e7eb' }}>
                    {member.photo && (
                      <img
                        src={getFileUrl(member, member.photo)}
                        alt={member.name}
                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                      />
                    )}
                  </div>
                  <div style={{ fontWeight: 600, fontSize: 15 }}>{member.name}</div>
                  {member.role && (
                    <div style={{ fontSize: 13, color: '#6b7280' }}>{member.role}</div>
                  )}
                </div>
              ))}
            </div>
            <div style={{ marginTop: 20, textAlign: 'center' }}>
              <button
                type="button"
                onClick={() => navigate('/qui-sommes-nous')}
                className="btn outline"
              >
                Découvrir toute l&apos;équipe
              </button>
            </div>
          </div>
        </section>
      )}

      <section style={{ marginTop: 40, background: '#fff' }}>
        <div style={{ maxWidth: 1200, margin: '0 auto', padding: '24px 20px 32px 20px' }}>
          <h2 style={{ fontSize: 24, marginBottom: 6, textAlign: 'center' }}>Pourquoi choisir AEF32 ?</h2>
          <p style={{ textAlign: 'center', margin: 0, color: '#6b7280', fontSize: 16 }}>Une entreprise locale qui vous accompagne de l&apos;étude à la maintenance, avec des solutions fiables et durables.</p>
          <div
            style={{
              marginTop: 20,
              display: 'grid',
              gridTemplateColumns: isMobile
                ? '1fr'
                : 'repeat(4, minmax(0, 1fr))',
              gap: 20,
            }}
          >
            <div style={{ background: '#fff', borderRadius: 14, padding: 16, boxShadow: '0 8px 18px rgba(15,23,42,0.04)', border: '1px solid #e5e7eb' }}>
              <h3 style={{ margin: '0 0 6px 0', fontSize: 16 }}>Expérience et savoir-faire</h3>
              <p style={{ margin: 0, fontSize: 14, color: '#6b7280' }}>Une équipe spécialisée dans les portails, automatismes et fermetures, avec des années d&apos;expérience terrain.</p>
            </div>
            <div style={{ background: '#fff', borderRadius: 14, padding: 16, boxShadow: '0 8px 18px rgba(15,23,42,0.04)', border: '1px solid #e5e7eb' }}>
              <h3 style={{ margin: '0 0 6px 0', fontSize: 16 }}>Accompagnement complet</h3>
              <p style={{ margin: 0, fontSize: 14, color: '#6b7280' }}>De l&apos;étude de votre projet à la pose et la maintenance, AEF32 reste votre interlocuteur unique.</p>
            </div>
            <div style={{ background: '#fff', borderRadius: 14, padding: 16, boxShadow: '0 8px 18px rgba(15,23,42,0.04)', border: '1px solid #e5e7eb' }}>
              <h3 style={{ margin: '0 0 6px 0', fontSize: 16 }}>Partenaires de confiance</h3>
              <p style={{ margin: 0, fontSize: 14, color: '#6b7280' }}>Des fabricants reconnus pour la qualité de leurs produits et la durabilité des équipements installés.</p>
            </div>
            <div style={{ background: '#fff', borderRadius: 14, padding: 16, boxShadow: '0 8px 18px rgba(15,23,42,0.04)', border: '1px solid #e5e7eb' }}>
              <h3 style={{ margin: '0 0 6px 0', fontSize: 16 }}>Service après-vente réactif</h3>
              <p style={{ margin: 0, fontSize: 14, color: '#6b7280' }}>En cas de besoin, une équipe disponible pour intervenir rapidement et assurer la continuité de vos installations.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="home-proximity-section">
        <div className="container-about-premium">
           <div className="proximity-card-elite shadow-signature">
              <div className="proximity-content-grid">
                 <div className="proximity-text">
                    <h2 className="title-with-accent">Un projet de portail ou d&apos;automatisme ?</h2>
                    <p className="p-major">
                       Parlez-nous de votre besoin et obtenez un accompagnement personnalisé ainsi qu&apos;un devis adapté à votre projet.
                    </p>
                    <div className="proximity-badges-row">
                       <div className="p-badge"><div className="p-dot"></div> Fiabilité</div>
                       <div className="p-badge"><div className="p-dot"></div> Sécurité</div>
                       <div className="p-badge"><div className="p-dot"></div> Durabilité</div>
                    </div>
                    <div className="proximity-actions-home">
                       <button onClick={() => navigate('/contact')} className="btn-emerald-signature-full">
                          Demander un devis <span className="arrow-icon">→</span>
                       </button>
                       <button onClick={() => navigate('/contact')} className="btn-emerald-signature-outline">
                          Prendre rendez-vous
                       </button>
                    </div>
                 </div>
                 {!isMobile && (
                   <div className="proximity-icon-box">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="map-icon-luxury"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>
                   </div>
                 )}
              </div>
           </div>
        </div>
        <style jsx>{`
          .home-proximity-section { padding: 80px 0; background: #fff; }
          .proximity-card-elite { 
             background: #f0fdf4; border-radius: 36px; border: 1px solid #f1f5f9; padding: 60px;
             position: relative; overflow: hidden;
          }
          .proximity-content-grid { display: grid; grid-template-columns: 1fr 200px; gap: 40px; align-items: center; }
          .title-with-accent { font-size: 28px; font-weight: 950; color: #0f172a; margin-bottom: 25px; position: relative; letter-spacing: -1px; }
          .title-with-accent::after { content: ''; position: absolute; left: 0; bottom: -10px; width: 40px; height: 3px; background: var(--accent); }
          .p-major { font-size: 18px; color: #475569; line-height: 1.6; margin-bottom: 30px; max-width: 650px; }
          .proximity-badges-row { display: flex; gap: 20px; flex-wrap: wrap; margin-bottom: 40px; }
          .p-badge { 
             background: #fff; border: 1px solid #e2e8f0; padding: 8px 16px; border-radius: 12px;
             font-size: 12px; font-weight: 800; color: var(--accent); text-transform: uppercase; letter-spacing: 0.5px;
             display: flex; align-items: center; gap: 8px;
             box-shadow: 0 4px 10px rgba(0,0,0,0.02);
          }
          .p-dot { width: 6px; height: 6px; border-radius: 50%; background: var(--accent); }
          
          .proximity-actions-home { display: flex; gap: 15px; flex-wrap: wrap; }
          .btn-emerald-signature-full {
             background: var(--accent); color: #fff; border: none; padding: 16px 32px; border-radius: 14px; 
             font-weight: 800; display: flex; align-items: center; gap: 10px; cursor: pointer; transition: all 0.3s;
             box-shadow: 0 8px 20px rgba(34, 197, 94, 0.2);
          }
          .btn-emerald-signature-full:hover { transform: translateY(-3px); background: var(--accent-600); box-shadow: 0 12px 25px rgba(34, 197, 94, 0.3); }
          .btn-emerald-signature-outline {
             background: transparent; color: #0f172a; border: 1.5px solid #0f172a; padding: 16px 32px; border-radius: 14px; 
             font-weight: 800; cursor: pointer; transition: all 0.3s;
          }
          .btn-emerald-signature-outline:hover { background: #0f172a; color: #fff; transform: translateY(-3px); }

          .proximity-icon-box { display: flex; justify-content: center; }
          .map-icon-luxury { width: 120px; height: 120px; color: var(--accent); opacity: 0.15; }

          @media (max-width: 900px) {
             .proximity-content-grid { grid-template-columns: 1fr; }
             .proximity-card-elite { padding: 40px 30px; }
             .title-with-accent { font-size: 24px; }
             .btn-emerald-signature-full, .btn-emerald-signature-outline { width: 100%; justify-content: center; }
          }
        `}</style>
      </section>

      <section style={{ marginTop: 40 }}>
        <div style={{ maxWidth: 1200, margin: '0 auto', padding: '0 20px 32px 20px' }}>
          <h2 style={{ fontSize: 24, marginBottom: 6, textAlign: 'center' }}>Avis Google</h2>
          <p style={{ textAlign: 'center', margin: 0, color: '#6b7280', fontSize: 14 }}>Quelques retours partagés par nos clients.</p>
          <div style={{ marginTop: 20, display: 'grid', gap: 16, gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, minmax(0, 1fr))' }}>
            {googleReviews.map((r, idx) => (
              <div key={idx} style={{ border: '1px solid #e5e7eb', borderRadius: 12, padding: 14, background: '#fff', boxShadow: '0 10px 25px rgba(15,23,42,0.04)', display: 'grid', gap: 8 }}>
                <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: 8 }}>
                  <div style={{ fontWeight: 600, fontSize: 15 }}>{r.name}</div>
                  <div className="muted" style={{ fontSize: 12, color: '#6b7280' }}>{r.time}</div>
                </div>
                {r.meta && <div className="muted" style={{ fontSize: 12, color: '#6b7280' }}>{r.meta}</div>}
                <div aria-label="Note 5 sur 5" style={{ display: 'flex', gap: 2, lineHeight: 1 }}>
                  {Array.from({ length: 5 }).map((_, i) => (
                    <span key={i} aria-hidden="true" style={{ color: '#f59e0b', fontSize: 14 }}>★</span>
                  ))}
                </div>
                <p style={{ margin: 0, fontSize: 14, color: '#374151', lineHeight: 1.45 }}>{r.text}</p>
              </div>
            ))}
          </div>
          <div style={{ marginTop: 20, textAlign: 'center' }}>
            <a
              href="https://www.google.com/search?sca_esv=f3c15013da1a5a7a&rlz=1C1IBEF_frFR1164FR1164&hl=fr-FR&sxsrf=AE3TifOkl2zMgyqPBUi5QyDPNKcX_7WjMA:1765217508600&q=AEF32+portails+et+automatismes+Avis&si=AMgyJEtREmoPL4P1I5IDCfuA8gybfVI2d5Uj7QMwYCZHKDZ-E1WzIvnKSW3jf8DL-gzHKacP_MjXVWJyl60ouR4KqjwvVeXa_pCKygA-GdnJJ1AZYXG04Ks%3D&uds=AOm0WdERhuFilvPO7wSsg2lpXEzDG65MrvVMvqQFveNcdyPFGZJYL4gLamig9tlKFvX1lAokdxvOpw6XmJt_URjfSIGKvSOmPjv-eG-3dEAFPquMO5igZFMppSOhxGJUvy-R9h1r-vUJ&sa=X&ved=2ahUKEwjTtrTUy66RAxV0RKQEHc_XM5kQ3PALegQIMRAF&biw=1536&bih=730&dpr=1.25"
              target="_blank"
              rel="noreferrer"
              className="btn outline"
            >
              Voir tous les avis sur Google
            </a>
          </div>
        </div>
      </section>

      {(!!references.length) && !error && (
        <section style={{ marginTop: 40 }}>
          <div style={{ maxWidth: 1200, margin: '0 auto', padding: '0 20px 32px 20px', display: 'grid', gap: 32 }}>
            <div>
              <h2 style={{ fontSize: 24, marginBottom: 6, textAlign: 'center' }}>Ils nous font confiance</h2>
              <p style={{ textAlign: 'center', margin: 0, color: '#6b7280', fontSize: 14 }}>Entreprises, collectivités et partenaires qui ont choisi AEF32 pour leurs projets.</p>
              <div className="home-references-grid" style={{ marginTop: 20, display: 'flex', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'stretch', gap: 16 }}>
                {references.map(ref => (
                  <div key={ref.id} style={{ width: isMobile ? 'calc((100% - 16px) / 2)' : 220, border: '1px solid #e5e7eb', borderRadius: 10, padding: 12, background: '#fff', display: 'grid', gap: 6 }}>
                    {ref.logo && (
                      <div style={{ marginBottom: 4, textAlign: 'center' }}>
                        <img
                          src={getFileUrl(ref, ref.logo)}
                          alt={ref.name}
                          style={{ maxHeight: 40, maxWidth: '100%', objectFit: 'contain' }}
                        />
                      </div>
                    )}
                    <div style={{ fontWeight: 600, fontSize: 14, textAlign: 'center' }}>{ref.name}</div>
                    {ref.description && (
                      <div className="muted" style={{ fontSize: 13, textAlign: 'center' }}>{ref.description}</div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      )}

      {warrantyOpen && (
        <div aria-modal="true" role="dialog" style={{ position: 'fixed', inset: 0, zIndex: 9999 }}>
          <div onClick={() => setWarrantyOpen(false)} style={{ position: 'absolute', inset: 0, background: 'rgba(2,6,23,0.45)' }} />
          <div style={{ position: 'relative', maxWidth: 900, margin: '60px auto', padding: '0 16px' }}>
            <div style={{ background: '#fff', borderRadius: 14, border: '1px solid #e5e7eb', boxShadow: '0 20px 45px rgba(15,23,42,0.20)', overflow: 'hidden' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 14px', borderBottom: '1px solid #e5e7eb' }}>
                <div style={{ fontWeight: 700, fontSize: 16 }}>Conditions de garantie</div>
                <button type="button" className="btn ghost" onClick={() => setWarrantyOpen(false)} style={{ padding: '4px 10px', borderRadius: 999, fontSize: 13 }}>Fermer</button>
              </div>
              <div style={{ padding: 16 }}>
                <div style={{ display: 'grid', gap: 12, color: '#374151', fontSize: 15, lineHeight: 1.55 }}>
                  <p style={{ margin: 0 }}>
                    <span style={{ display: 'inline-block', fontSize: 12, fontWeight: 700, background: '#f0fdf4', color: '#166534', border: '1px solid #bbf7d0', padding: '2px 8px', borderRadius: 999, marginRight: 8 }}>À vie</span>
                    À partir du 1er janvier 2024, la fabrication de nos portails (hors accessoires et motorisation intégrée) est garantie à vie contre tout défaut de fabrication à compter de la semaine de livraison et dans les 15 jours à partir du moment où le bénéficiaire a eu connaissance du défaut, et sous réserve du respect absolu des conditions d’utilisation et d’entretien.
                  </p>
                  <p style={{ margin: 0 }}>
                    <span style={{ display: 'inline-block', fontSize: 12, fontWeight: 700, background: '#eef2ff', color: '#3730a3', border: '1px solid #c7d2fe', padding: '2px 8px', borderRadius: 999, marginRight: 8 }}>25 ans</span>
                    La garantie de fabrication de nos clôtures — garde-corps (excepté modèles en verre) — brise‑vues — est de 25 ans contre tout défaut de fabrication à compter de la semaine de livraison et dans les 15 jours à partir du moment où le bénéficiaire a eu connaissance du défaut et sous réserve du respect absolu des conditions d’utilisation et d’entretien.
                  </p>
                  <p style={{ margin: 0 }}>
                    <span style={{ display: 'inline-block', fontSize: 12, fontWeight: 700, background: '#ecfeff', color: '#155e75', border: '1px solid #a5f3fc', padding: '2px 8px', borderRadius: 999, marginRight: 8 }}>2 ans</span>
                    Concernant les brise‑soleil et les garde‑corps en verre, les produits sont garantis 2 ans contre tout vice de fabrication à compter de la date de livraison.
                  </p>
                  <p style={{ margin: '4px 0 0 0', fontSize: 13, color: '#6b7280' }}>
                    Sous réserve du respect des conditions d’utilisation et d’entretien. Déclaration sous 15 jours à compter de la livraison.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
